import React, { useState } from 'react';
import { Box } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import CargaMasivaLista from "../ComponentList/CargaMasivaLista";
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import { ICliente } from "../../entities/catalogos/ICliente";
import { IUsuario } from '../../entities/catalogos/IUsuario';
import { IHelp } from '../help/Help';
interface StateProps {
    solicitud: Solicitud
    solicitudCopia: Solicitud
    cliente: ICliente
    usuario: IUsuario
    cotizacionID: number
    ayuda: IHelp
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    principal: {
      backgroundColor: "#fff",
      width: "100%",
      height: "100%",
    },
    content: {
      padding: theme.spacing(0, 4, 3, 4),
    },
  })
);

const BodyCargaMasiva: React.FC = () => {
        const [cotizacionId, setCotizacionID] = useState(0);
        const getCotizacionId = (cotizacionId: number) => {
            if (cotizacionId > 0) {
                setCotizacionID(cotizacionId);
            }
        }
  const classes = useStyles();

  return (
    <div className={classes.principal}>
      <Box className="section-title" p={2}>
        {/* Título consistente con tu UI */}
        Solicitudes Masivas
      </Box>
      <Box className={classes.content}>

      </Box>
    </div>
  );
};

export default BodyCargaMasiva;
